export default "__VITE_PUBLIC_ASSET__cca37696__"